// Communication Method Start
export const COMMUNICATION_METHOD_WEB_CONFERERENCE = "Web Conference";
export const COMMUNICATION_METHOD_PHONE = "Phone";
// Communication Method End

export const WEB_CONFERERENCE_TYPE_TORCHLITE = "Torchlite";
export const WEB_CONFERERENCE_TYPE_PROVIDE_CONFERERENCE_URL =
  "I will provide a conference URL";
